import { CardMedia } from "@mui/material";
import { useContext } from "react";
import { ConfigContext } from "../../App/App";
import styles from './HeroLogo.module.css';

function HeroLogo() {
    const config = useContext(ConfigContext);
    const configuredName = (config.TenantName ?? "").trim();
    const headlineSource = (config.HomeHeadline2 || "").toString();
    const headlineMatch = /welcome to\s*(.*)/i.exec(headlineSource);
    const headlineName = headlineMatch ? headlineMatch[1].replace(/[!.,]+$/, "").trim() : "";
    const indexName = (config.IndexName || "").toString().trim();
    const institutionName = configuredName || headlineName || indexName || "School";
    const altText = `${institutionName} logo`;
    return (
        <CardMedia
            title={altText}
            sx={{
                px: 3,
                py: 3,
                height: '100%',
                background: config.TertiaryColor,
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                overflow: 'hidden',
                borderRadius: `${config.BorderRadiusNumber}px`
            }}
        >
            <img className={styles.heroLogo} src={config.LogoUrl} alt={altText} />
        </CardMedia>)
}

export default HeroLogo
